"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIcon = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var CheckDefault_1 = __importDefault(require("../Icon/generated/CheckDefault"));
var MinusCircleFilled_1 = __importDefault(require("../Icon/generated/MinusCircleFilled"));
var util_1 = require("../../util");
function StepIcon(props) {
    var status = props.status, Icon = props.icon, style = props.style, rest = __rest(props, ["status", "icon", "style"]);
    var _a = styles_1.useStyles(function (theme) { return createStyles(theme, status); }), classes = _a.classes, css = _a.css;
    var hasBackground = getHasBackground(status, Icon);
    return (react_1.default.createElement("span", __assign({ className: css(classes.iconContainer, style) }, rest),
        hasBackground && react_1.default.createElement("div", { className: classes.background, "data-testid": 'background' }),
        Icon && react_1.default.createElement(Icon, { className: classes.icon }),
        !Icon && status === 'completed' && react_1.default.createElement(CheckDefault_1.default, { className: classes.icon, "data-testid": 'check-icon' }),
        !Icon && status === 'inactive' && react_1.default.createElement(MinusCircleFilled_1.default, { className: classes.icon, "data-testid": 'minus-icon' })));
}
exports.StepIcon = StepIcon;
var createStyles = function (theme, status) { return ({
    iconContainer: {
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.5rem',
        height: '1.5rem',
        textAlign: 'center',
        position: 'relative',
    },
    background: {
        width: '1rem',
        height: '1rem',
        borderRadius: '50%',
        position: 'absolute',
        top: 'calc(50% - 0.5rem)',
        left: 'calc(50% - 0.5rem)',
        background: status === 'incompleted' ? theme.pallete.gray.c60 : theme.pallete.primary.main,
        boxShadow: (status === 'active' && styles_1.focusBoxShadow(theme, 'primary')) ||
            (status === 'completed' && "0 0 0 4px " + theme.pallete.primary.main),
        transition: 'all .4s ease',
    },
    icon: {
        zIndex: 1,
        fill: status === 'completed' || status === 'active' ? theme.pallete.primary.c100 : theme.pallete.gray.c60,
        width: '1.25rem',
        height: '1.25rem',
    },
}); };
var getHasBackground = function (status, overridedIcon) {
    return status === 'active' || status === 'completed' || (status === 'incompleted' && util_1.isNil(overridedIcon));
};
//# sourceMappingURL=StepIcon.js.map